export default __webpack_public_path__ + "453145116e5baa79e41b80d9c00caaba.png";